import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CategoriesAccordion } from "@/components/site/HomeSections";
import { CtaBand } from "@/components/site/Sections";
import { IMAGES } from "@/components/site/data";

export default function Categories() {
  return (
    <>
      <PageHero overline="What We Source" title="Products Selected for International Potential." image={IMAGES.spices}>
        <p>
          RSC Imports continuously reviews manufacturers, producers and brands across international
          markets. Our sourcing strategy is driven by product quality, supply reliability,
          commercial scalability, destination-market relevance and long-term growth potential.
        </p>
      </PageHero>

      <section data-testid="categories-page-section" className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <CategoriesAccordion />
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="Does Your Product Belong Here?"
        text="Our procurement team reviews new product categories and suppliers throughout the year."
        buttonLabel="Submit Your Products"
        to="/partner"
      />
    </>
  );
}
